module.exports = __webpack_public_path__ + "img/personal9.5e9607ae.png";